import { render, staticRenderFns } from "./split.vue?vue&type=template&id=6d31f576&scoped=true&"
import script from "./split.vue?vue&type=script&lang=js&"
export * from "./split.vue?vue&type=script&lang=js&"
import style0 from "./split.vue?vue&type=style&index=0&id=6d31f576&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31f576",
  null
  
)

export default component.exports